import React, { useState } from "react";
import { toast } from "sonner";
import { AppHeader } from "../components/AppHeader";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Badge } from "../components/ui/badge";
import { api, erroMsg } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { dataHora } from "../lib/format";
import { KeyRound, Loader2 } from "lucide-react";

export default function Perfil() {
  const { user } = useAuth();
  const [form, setForm] = useState({ atual: "", nova: "", confirmar: "" });
  const [enviando, setEnviando] = useState(false);

  const alterar = async (e) => {
    e.preventDefault();
    if (form.nova.length < 4) {
      toast.error("A nova senha deve ter pelo menos 4 caracteres.");
      return;
    }
    if (form.nova !== form.confirmar) {
      toast.error("A confirmação não confere com a nova senha.");
      return;
    }
    setEnviando(true);
    try {
      await api.post("/auth/change-password", {
        senha_atual: form.atual,
        senha_nova: form.nova,
      });
      toast.success("Senha alterada com sucesso");
      setForm({ atual: "", nova: "", confirmar: "" });
    } catch (err) {
      toast.error(erroMsg(err));
    } finally {
      setEnviando(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50">
      <AppHeader />
      <div className="mx-auto max-w-3xl px-3 py-6 sm:px-6">
        <h1 className="font-display text-[20px] font-bold tracking-tight text-slate-900">
          Minha conta
        </h1>

        <div className="mt-4 rounded-xl border border-slate-200 bg-white p-5">
          <div className="grid gap-4 sm:grid-cols-2">
            <div>
              <div className="text-[11px] font-semibold uppercase tracking-wide text-slate-500">
                Nome
              </div>
              <div className="text-[15px] font-medium text-slate-900">{user?.nome}</div>
            </div>
            <div>
              <div className="text-[11px] font-semibold uppercase tracking-wide text-slate-500">
                E-mail
              </div>
              <div className="text-[15px] font-medium text-slate-900">{user?.email}</div>
            </div>
            <div>
              <div className="text-[11px] font-semibold uppercase tracking-wide text-slate-500">
                Perfil
              </div>
              <Badge variant="secondary" className="mt-0.5">
                {user?.role === "admin" ? "Administrador" : "Representante"}
              </Badge>
            </div>
            <div>
              <div className="text-[11px] font-semibold uppercase tracking-wide text-slate-500">
                Região
              </div>
              <div className="text-[15px] font-medium text-slate-900">{user?.regiao || "—"}</div>
            </div>
            <div>
              <div className="text-[11px] font-semibold uppercase tracking-wide text-slate-500">
                Telefone
              </div>
              <div className="text-[15px] font-medium text-slate-900">{user?.telefone || "—"}</div>
            </div>
            <div>
              <div className="text-[11px] font-semibold uppercase tracking-wide text-slate-500">
                Criado em
              </div>
              <div className="text-[15px] font-medium text-slate-900">
                {dataHora(user?.criado_em)}
              </div>
            </div>
          </div>
        </div>

        <form onSubmit={alterar} className="mt-4 rounded-xl border border-slate-200 bg-white p-5">
          <div className="mb-4 flex items-center gap-2">
            <KeyRound className="h-4 w-4 text-primary" />
            <h2 className="font-display text-[15px] font-semibold text-slate-900">Alterar senha</h2>
          </div>
          <div className="grid gap-3 sm:grid-cols-3">
            <div className="space-y-1.5">
              <Label htmlFor="atual">Senha atual</Label>
              <Input
                id="atual"
                type="password"
                value={form.atual}
                onChange={(e) => setForm({ ...form, atual: e.target.value })}
                className="h-11"
                data-testid="perfil-senha-atual"
              />
            </div>
            <div className="space-y-1.5">
              <Label htmlFor="nova">Nova senha</Label>
              <Input
                id="nova"
                type="password"
                value={form.nova}
                onChange={(e) => setForm({ ...form, nova: e.target.value })}
                className="h-11"
                data-testid="perfil-senha-nova"
              />
            </div>
            <div className="space-y-1.5">
              <Label htmlFor="conf">Confirmar nova senha</Label>
              <Input
                id="conf"
                type="password"
                value={form.confirmar}
                onChange={(e) => setForm({ ...form, confirmar: e.target.value })}
                className="h-11"
                data-testid="perfil-senha-confirmar"
              />
            </div>
          </div>
          <Button type="submit" className="mt-4 h-11" disabled={enviando} data-testid="perfil-salvar-senha">
            {enviando && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
            Alterar senha
          </Button>
        </form>
      </div>
    </div>
  );
}
